import axios from 'axios';
import { useErrorHandler } from 'tools/error-handler';
import { AccessPoints, VisitAccessPoint } from 'services/access-points/access-points.service';

export const useAPIAccessPoints = (): AccessPoints => {
    // navigateOnNetworkError: false — el fallo de carga tiene su propio estado y
    // reintento en la pantalla; sacar al usuario a /offline le haría perder lo tipeado.
    const errorHandler = useErrorHandler({ navigateOnNetworkError: false });

    const listVisitAccessPoints = async (accessToken: string): Promise<VisitAccessPoint[]> => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API_MOBILE_PASSCODES_BASE_URL + `/user/visit-access-points`,
                { headers: { Authorization: 'Bearer ' + accessToken } },
            );
            return (response.data as VisitAccessPoint[]) || [];
        } catch (err: unknown) {
            errorHandler(err);
            throw err;
        }
    };

    return { listVisitAccessPoints };
};
